var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":_vm.loadImg,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }